import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import { schema } from "../../../../../../constants/form/cdoc/addUser";
import Grid from "../../../../../../components/Grid";

import Submit from "../../../../../../components/Form/Submit";

import { hideModal } from "../../../../../../store/actions/modal";

import { StateDto } from "../../../../../../types/states.dto";
import { resetUpdateCDOCs } from "../../../../../../store/actions/cdoc";

import { setFormData } from "../../../../../../helpers/formData";
import { updateSlideShow } from "../../../../../../store/actions/slideshow";

const Component = ({
  updateStates,
  slideshow,
}: {
  updateStates: StateDto;
  slideshow: {
    _id: string;
    published: boolean;
    name: string;
    description: string;
    __v: number | string;
  };
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    dispatch(
      updateSlideShow({
        _id: slideshow._id,
        body: setFormData(
          {
            published: !slideshow.published,
            available: !slideshow.published,
            __v: slideshow.__v,
          },
          []
        ),
      })
    );

    setFormActions(actions);
  };

  useEffect(() => {
    if (updateStates.success) {
      dispatch(hideModal());
      formActions?.resetForm();
    }
  }, [updateStates]);

  return (
    <Modal
      name="private-video"
      title={`¿Seguro quieres cambiar el status del contenido a ${
        !!slideshow.published ? "Privado" : "Publico"
      }?`}
      description={
        !!slideshow.published
          ? `El Video se esconderá en todos los lugares en donde esta publicado. Ningún usuario podrá acceder a el.`
          : `El Video se mostrara en todos los lugares en donde esta publicado. Los usuarios podran acceder.`
      }
    >
      <Formik
        initialValues={{}}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="invite-academy-modal-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <Center gap={"10px"}>
                    <Submit
                      isSubmmiting={isSubmitting}
                      form="invite-academy-modal-form"
                      color="Primary"
                      style={{ width: "170px" }}
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({ slideshowStore }) => {
  const { states: updateStates } = slideshowStore.update;
  return { updateStates };
};

export default connect(states)(Component);
